import React from "react";

export const Loading = ({ display = false, size = Size.large, }: { display?: boolean; size?: keyof typeof Size; }) => {
    React.useEffect(() => {
        document.body.style.overflowY = display ? "hidden" : "scroll";

        return () => {
            document.body.style.overflowY = "scroll";
        };
    }, [display]);

    if (!display) return null;

    return (
        <div className="fixed z-20 w-full h-full left-0 top-0">
            <div className="flex w-full h-full justify-center items-center bg-white/[.8]">
                <div className="box-border relative block">
                    <div
                        className={formatClass(`w border-b-[0.18rem] border-l-[0.18rem] border-b-staples-red border-l-staples-red absolute
      rounded-sm animate-loadingChild1
      ${size === Size.large ? "w-16 h-16" : ""}
      ${size === Size.medium ? "w-12 h-12" : ""}
      ${size === Size.small ? "w-4 h-4" : ""}
      `)}
                    />
                    <div
                        className={`border-t-[0.18rem] border-r-[0.18rem] border-t-staples-red border-r-staples-red absolute
      rounded-sm animate-loadingChild2
      ${size === Size.large ? "w-16 h-16" : ""}
      ${size === Size.medium ? "w-12 h-12" : ""}
      ${size === Size.small ? "w-4 h-4" : ""}
      `}
                    />
                </div>
            </div>
        </div>
    );
};
const formatClass = (className: string) => className.trim().replace(/\s(?=\s)/g, "");
enum Size { small = "small", medium = "medium", large = "large" }